import { DebugElement, Injectable } from '@angular/core';
import { Usuario, Config, DetalleSede } from '@/Interfaces';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public idPadre: number;
  public Token: string = '';
  public JWT: string = '';

  public TipoDoc: number = 1; 
  public Directorio: boolean = false;
  public LoadDir: boolean = false;  
  public SedeUsuario: string = '';
  public DescripcioPadre: string = '';
  public menuPAC: boolean = false;
  public current: boolean = false;
  public ingresoSinUsuario: boolean = false;
  public toolbar: boolean = false;
  public imgmenu: string = "assets/images/menuAFI.PNG"
  public usuario: Usuario;
  public notificacionesCount: number = 0; 
  public notificaciones: any; 
  public esErrorPeticion: boolean;
  public idOperacionSeleccionada: number = 0;
  public llavePublicaOficinaVirtual: string; 
  public defaultImage: string = "assets/icons/OFV/Icono_numero%20documento.svg";
  public ListDetalleSede: DetalleSede;
  public NombreSedeCar: string;
  public NitSedeCar: string;
  public IdSedeCar: number;
  public config: Config;
  public globalService: any;
  public currentUser: any;
  public imagenBackground: boolean = true;
  public usarRutaExterna: boolean = false;
  public disenoTeEscuchamos: boolean = false;
  public rutaExterna: string = "kyjcdkht";
  
  //Parametros Cargue Archivos
  MAXIMOREGISTROSXARCHIVO: string;
  MAXIMOREGISTROSXARCHIVOZIP: string;
  MODULOINFORMACION: string;
  NUMMAXIMOCARGUE: string;
  TABLAMOVIMIENTODETALLE: string;
  TABLAMOVIMIENTOENCABEZADO: string;
  TAMANOMAXIMOARCHIVO: string;
  TAMANOMAXIMOARCHIVOZIP: string;
  TEMAINFORMACION: string;
  TIEMPOROJO: string;
  TIEMPOVERDE: string;
  TIMEOUTBULKCOPY: string;
  TIMEOUTREPORTES: string;
  TIMEOUTVALIDACIONCARGUE: string;
  TIPOFUENTE: string;
  TIPOIDENTIFICACION: string;
  TIPOREGIMEN: string;
  TOTALREGISTROSDETALLE: string;
  TOTALREGISTROSENCABEZADO: string;
  VALIDACIONCOHERENCIADATOS: string;
  VALIDACIONTIPOFORMATO: string;

  constructor(public router: Router) {
    if (sessionStorage.getItem('globalService') != undefined) {
      if (this.Token == null || this.Token == "") {
        let globalService = JSON.parse(sessionStorage.getItem('globalService'));
        this.JWT = globalService.JWT;
        this.DescripcioPadre = globalService.DescripcioPadre;
        this.menuPAC = globalService.menuPAC;
        this.current = globalService.current;
        this.toolbar = globalService.toolbar;
        this.imgmenu = globalService.imgmenu; 

        this.notificaciones = globalService.notificaciones;
        this.idPadre = globalService.idPadre = globalService.idPadre;
        this.Token = (globalService.Token == null || globalService.Token == "" ? JSON.parse(sessionStorage.getItem('configOficina')).Token : globalService.Token);
        let usuario = JSON.parse(sessionStorage.getItem('usuarioOficinaVirtual'));
        if (usuario != null && (usuario.imagenUsuario == undefined || usuario.imagenUsuario == "" || usuario.imagenUsuario == null)) {
          usuario.imagenUsuario = this.defaultImage;
        }
        if (usuario != null) {
          usuario.imagenUsuario = this.defaultImage;
        }
        this.usuario = usuario;
      }
    }
    if (sessionStorage.getItem("ingresoSinUsuario") != undefined && (sessionStorage.getItem('globalService') != undefined || !this.current)) {
      this.ingresoSinUsuario = JSON.parse(sessionStorage.getItem("ingresoSinUsuario"));
    }

  }
}


